import { Medewerker } from "./medewerker.model";

export class WorkProcess {
  werkprocesNummer: number;
  clientNummer: number;
  indicatieRaadplegen: string;
  gemeenteKode: number;
  gemeenteNaam: string;
  zaakIdentificatie: string;
  statusWerkproces: number;
  omschrijvingStatus: string;
  datumStatusWerkproces: string;
  vervaldatumFase: string;
  kodeRegeling: number;
  omschrijvingRegeling: string;
  kodeGroep: string;
  omschrijvingSoortWerkproces: string;
  aardBijstand: number;
  omschrijvingAardBijstand: string;
  kodeMedewerker: string;
  naamMedewerker: string;
  kodeFase: string;
  clientNummerPartner: number;
  medewerker: Medewerker | null;

  constructor(data: WorkProcess) {
    this.werkprocesNummer = data.werkprocesNummer;
    this.clientNummer = data.clientNummer;
    this.indicatieRaadplegen = data.indicatieRaadplegen;
    this.gemeenteKode = data.gemeenteKode;
    this.gemeenteNaam = data.gemeenteNaam;
    this.zaakIdentificatie = data.zaakIdentificatie;
    this.statusWerkproces = data.statusWerkproces;
    this.omschrijvingStatus = data.omschrijvingStatus;
    this.datumStatusWerkproces = data.datumStatusWerkproces;
    this.vervaldatumFase = data.vervaldatumFase;
    this.kodeRegeling = data.kodeRegeling;
    this.omschrijvingRegeling = data.omschrijvingRegeling;
    this.kodeGroep = data.kodeGroep;
    this.omschrijvingSoortWerkproces = data.omschrijvingSoortWerkproces;
    this.aardBijstand = data.aardBijstand;
    this.omschrijvingAardBijstand = data.omschrijvingAardBijstand;
    this.kodeMedewerker = data.kodeMedewerker;
    this.naamMedewerker = data.naamMedewerker;
    this.kodeFase = data.kodeFase;
    this.clientNummerPartner = data.clientNummerPartner;
    this.medewerker = data.medewerker;
    }
}
